const MIN_TEMP = -10
const MAX_TEMP = 40
const AUTO_REFRESH_INTERVAL_SEC = 3600
    
export default {
    MIN_TEMP: MIN_TEMP,
    MAX_TEMP: MAX_TEMP,
    AUTO_REFRESH_INTERVAL_SEC: AUTO_REFRESH_INTERVAL_SEC,
}